<template>
  <a-form-model
    ref="form"
    :model="form"
    :rules="rules"
    :label-col="{ span: 6 }"
    :wrapper-col="{ span: 18 }"
    @submit.prevent="handleSubmit"
  >
    <a-form-model-item :label="locale === 'zh' ? '意向产品' : 'Product'" prop="product">
      <a-select
        v-model="form.product"
        :placeholder="$t('inquiry.productPlaceholder')"
        showSearch
        :filterOption="filterProduct"
        allowClear
      >
        <a-select-option v-for="p in products" :key="p.id" :value="locale === 'zh' ? p.nameZh : p.name">
          {{ locale === 'zh' ? p.nameZh : p.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>

    <a-form-model-item :label="locale === 'zh' ? '姓名' : 'Name'" prop="name">
      <a-input v-model="form.name" :placeholder="locale === 'zh' ? '请输入您的姓名' : 'Your name'" />
    </a-form-model-item>

    <a-form-model-item :label="locale === 'zh' ? '公司' : 'Company'" prop="company">
      <a-input v-model="form.company" :placeholder="locale === 'zh' ? '请输入公司名称' : 'Company name'" />
    </a-form-model-item>

    <a-form-model-item :label="locale === 'zh' ? '邮箱' : 'Email'" prop="email">
      <a-input v-model="form.email" :placeholder="locale === 'zh' ? '请输入邮箱地址' : 'Email address'" />
    </a-form-model-item>

    <a-form-model-item :label="locale === 'zh' ? '电话' : 'Phone'" prop="phone">
      <a-input v-model="form.phone" :placeholder="locale === 'zh' ? '请输入联系电话' : 'Phone number'" />
    </a-form-model-item>

    <a-form-model-item :label="locale === 'zh' ? '需求' : 'Requirements'" prop="message">
      <a-textarea
        v-model="form.message"
        :rows="4"
        :placeholder="$t('inquiry.messagePlaceholder')"
      />
    </a-form-model-item>

    <a-form-model-item :wrapper-col="{ offset: 6, span: 18 }">
      <a-button
        type="primary"
        html-type="submit"
        :loading="submitting"
        size="large"
        block
        style="background: #E74C3C; border-color: #E74C3C;"
      >
        {{ $t('inquiry.submit') }}
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
export default {
  name: 'InquiryForm',
  props: {
    productName: { type: String, default: '' }
  },
  data() {
    return {
      submitting: false,
      form: {
        product: '',
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    }
  },
  computed: {
    locale() {
      return this.$store.locale
    },
    products() {
      return this.$store.products
    },
    rules() {
      return {
        name: [{ required: true, message: this.$t('inquiry.required'), trigger: 'blur' }],
        email: [
          { required: true, message: this.$t('inquiry.required'), trigger: 'blur' },
          { type: 'email', message: this.$t('inquiry.emailInvalid'), trigger: 'blur' }
        ],
        message: [{ required: true, message: this.$t('inquiry.required'), trigger: 'blur' }]
      }
    }
  },
  mounted() {
    if (this.productName) {
      this.form.product = this.productName
    }
  },
  methods: {
    filterProduct(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true
          // 模拟提交
          setTimeout(() => {
            this.submitting = false
            this.$message.success(this.$t('inquiry.success'))
            this.$refs.form.resetFields()
            this.$emit('success')
          }, 1500)
        }
      })
    }
  }
}
</script>
